import type { AdSet, Campaign } from "~/ui-rtk/api/types/paid-media.types"

/** Meta returns budgets as minor units (cents) in a string. */
export function centsToAmount(cents?: string): number | null {
  if (!cents) return null
  const value = parseInt(cents, 10)
  return Number.isFinite(value) && value > 0 ? value / 100 : null
}

export function formatMoney(amount: number): string {
  return amount.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  })
}

/** The budget a campaign or ad set holds itself, or null when it has none. */
export function ownBudget(
  entity: Campaign | AdSet,
): { type: "DAILY" | "LIFETIME"; amount: number } | null {
  const daily = centsToAmount(entity.daily_budget)
  if (daily !== null) return { type: "DAILY", amount: daily }
  const lifetime = centsToAmount(entity.lifetime_budget)
  if (lifetime !== null) return { type: "LIFETIME", amount: lifetime }
  return null
}

export function describeBudget(entity: Campaign | AdSet): string {
  const budget = ownBudget(entity)
  if (!budget) return "—"
  return `${formatMoney(budget.amount)} ${budget.type === "DAILY" ? "/ day" : "lifetime"}`
}

/** Parse a dollar input into whole cents; null when it is not a positive amount. */
export function parseAmountToCents(input: string): number | null {
  const value = Number(input.trim())
  if (!input.trim() || !Number.isFinite(value) || value <= 0) return null
  return Math.round(value * 100)
}
